import React from 'react';
import PropTypes from 'prop-types';

const SendLetterDownload = ({ color, width, height, ...other }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    {...other}
  >
    <path
      d="M20 40c-4.4 0-8-3.6-8-8 0-3.7 2.6-6.8 6.1-7.7C19.6 19.7 24 16 29 16c5.3 0 9.7 4 10.3 9.2 5.3 0.4 8.7 4 8.7 8.3 0 4.5-3.6 7.5-8 7.5H20z"
      fill={color}
      opacity="0.3"
    />

    <g transform="translate(20, 23) scale(0.9)">
      <path
        d="M8,11.851l10.373-.972L8,9.906V5.688a.417.417,0,0,1,.588-.38L20.121,10.5a.417.417,0,0,1,0,.76L8.588,16.449A.417.417,0,0,1,8,16.069Z"
        transform="translate(-1.333 -0.879)"
        fill={color}
      />
      <path
        d="M3.333,14.333h.833a.833.833,0,1,1,0,1.667H3.333a.833.833,0,0,1,0-1.667Zm-2.5-4.167H4.167a.833.833,0,1,1,0,1.667H.833a.833.833,0,0,1,0-1.667ZM3.333,6h.833a.833.833,0,1,1,0,1.667H3.333A.833.833,0,1,1,3.333,6Z"
        transform="translate(0 -1)"
        fill={color}
        opacity="0.3"
      />
    </g>

    <path
      d="M32 46v6M29 49l3 3 3-3"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

SendLetterDownload.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

SendLetterDownload.defaultProps = {
  color: '#FFFFFF',
  width: 64,
  height: 64,
};

export default SendLetterDownload;



// WEBPACK FOOTER //
// ./src/components/Icons/SendLetterDownload.jsx